export const FORMATS = {
  admin: 'HH:mm DD.MM.YYYY',
  full: 'DD MMMM YYYY | H:mm',
};
